export const saveStatusTestIds = {
  text: 'save-status',
};
